<template>
  <Dialog
    custom-class="pg-dialog-form pg-dialog"
    top
    :fullscreen="fullscreen"
    :showClose="showClose"
    :closeOnClickModal="closeOnClickModal"
    :closeOnPressEscape="closeOnPressEscape"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    @close="close"
    @closed="closed"
    @open="getFormData"
    :z-index="zIndex"
  >
    <div v-if="tip" class="dialog-tip" :style="tipStyle">{{ tip }}</div>
    <PgForm
      v-if="!!formData"
      ref="pgFormRef"
      class="pg-dialog-form__form"
      :class="{
        'pg-dialog-form__form--basic-bg': basicBackground,
        'pg-dialog-form__form--not-padding': notPadding,
      }"
      :formItems="formItems"
      :formItemsCode="formItemsCode"
      :extendCompileData="{ setFormData, ...extendCompileData }"
      :model="formData"
    >
    </PgForm>
    <template #footer>
      <slot name="footer" :formData="formData">
        <ElButton style="min-width: 120px" round @click="handleCancel()" v-if="cacelText">{{
          cacelText
        }}</ElButton>
        <ElButton
          style="min-width: 120px"
          type="primary"
          round
          @click="submit()"
          :loading="sureLoading"
          v-if="sureText"
          >{{ sureText }}</ElButton
        >
        <ElButton
          style="min-width: 120px"
          type="primary"
          round
          @click="submit('continue')"
          :loading="sureLoading"
          v-if="sureAndContinueText"
          >{{ sureAndContinueText }}</ElButton
        >
      </slot>
    </template>
  </Dialog>
</template>
<script setup>
import { Dialog } from 'element-ui'
import { PgForm } from '../../form/index'
import {
  useDrawerPack,
  useBeforValueActionsProvideChild,
  useFormModifyDialog,
} from '../../../hooks/index'
import { toRefs, reactive } from 'vue'
import { useGetForm } from '../../../hooks/use-get-form'
import { useSure } from '../hook/use-sure'

const props = defineProps({
  showClose: {
    type: Boolean,
    default: true,
  },
  closeOnClickModal: {
    type: Boolean,
    default: true,
  },
  fullscreen: Boolean,
  closeOnPressEscape: {
    type: Boolean,
    default: true,
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  basicBackground: Boolean,
  notPadding: Boolean,
  title: {
    type: String,
    default: '选择',
  },
  cacelText: {
    type: String,
    default: '取消',
  },
  sureText: {
    type: String,
    default: '确定',
  },
  width: {
    type: String,
    default: '340px',
  },
  zIndex: {
    type: Number,
    default: 450,
  },
  formItems: [Array, Object],
  formItemsCode: String,
  extendCompileData: Object,
  formModel: Object,
  formMethod: String,
  formUrl: String,
  formParam: Object,
  getFormDataAfter: Function,
  submitUrl: String,
  submitParam: [Object, Function],
  submitMethod: {
    type: String,
    default: 'post',
  },
  successTip: String,
  onOK: Function,
  modifyTip: Boolean,
  sureAndContinueText: String,
  tip: String,
  tipStyle: Object,
  afterCallback: Function,
})

const emit = defineEmits([
  'update:visible',
  'close',
  'closed',
  'on-cancel',
  'on-ok',
  'on-ok-and-continue',
])

const { setModifyFlag, checkModifyFlag } = useFormModifyDialog(props.modifyTip)

const {
  formModel,
  formUrl,
  formParam,
  formMethod,
  visible,
  submitUrl,
  getFormDataAfter,
  submitMethod,
  submitParam,
} = toRefs(props)
const { showDrawer, close, closed, onCancel, closeDrawer, handleCancel } = useDrawerPack(
  visible,
  emit,
  checkModifyFlag
)
const { formData, getFormData, setFormData } = useGetForm({
  formModel,
  formUrl,
  formParam,
  getFormDataAfter,
  formMethod,
})

const { pgFormRef, sureLoading, sure, validate } = useSure({
  formData,
  submitUrl,
  submitMethod,
  successTip: props.successTip,
  submitParam,
})
const submit = async (value) => {
  const res = await sure()
  if (res) {
    setModifyFlag(false)
    if (props.onOK) {
      props.onOK(res)
    } else {
      if (value === 'continue') {
        emit('on-ok-and-continue', res)
        getFormData()
      } else {
        closeDrawer()
        emit('on-ok', res)
      }
    }
  }
}

useBeforValueActionsProvideChild({
  formReactive: reactive({ formData }),
  actions: null,
  callback: () => {
    if (props.modifyTip) {
      setModifyFlag(true)
    }
  },
  afterCallback: (param) => props.afterCallback?.({ ...param, formData: formData.value }),
})

defineExpose({
  validate,
})
</script>
<style lang="scss">
@import '../style/dialog-form.scss';
</style>
